module.exports = __webpack_public_path__ + "img/alert.b09c2a21.svg";